import { memo } from 'react';
import { IvrEvent } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-path/v1/api.pb';
import { PhoneEventsOrg } from '@wetags/phone-events';
import { Trans, useTranslation } from '@frontend/i18n';
import { DotRow, EventRowList, formatTime } from '../../utils/get-event-accordion-body';

export const IVREvent = memo(
  ({ dtmfEvents, callerName }: { dtmfEvents?: IvrEvent['dtmfEvents']; callerName?: string }) => {
    const { t } = useTranslation('calls');
    const [isAirEventsUiEnabled] = PhoneEventsOrg.useWetag('fe-air-events-ui');

    if (!isAirEventsUiEnabled) {
      return (
        <>
          {dtmfEvents?.map((dtmf, idx) => (
            <DotRow
              key={dtmf.key}
              message={
                <Trans t={t}>
                  {callerName} selected <strong>Option {dtmf.key}</strong>
                </Trans>
              }
              time={formatTime(dtmf.createdAt)}
              hideDot={idx === (dtmfEvents?.length ?? 1) - 1}
            />
          ))}
        </>
      );
    }

    const events =
      dtmfEvents?.map((dtmf) => ({
        message: (
          <Trans t={t}>
            {callerName} selected <strong>Option {dtmf.key}</strong>
          </Trans>
        ),
        time: formatTime(dtmf.createdAt),
      })) ?? [];

    return <EventRowList events={events} />;
  }
);

IVREvent.displayName = 'IVREvent';
